export default "__VITE_ASSET__CukkfB8P__"